const requestFailCallback = function (error) {
    // Do something with request error
    return Promise.reject(error);
};
const listingServiceResponseSuccessCallback = function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const { status, message, data, response_code } = response.data;
    if (status === "SUCCESS") {
        const { result, total_count } = data;
        return (total_count !== undefined && data) || result || data;
    }
    // Returning response code and message in case of status different than SUCCESS
    return Promise.reject(new Error(message, {
        cause: {
            //@ts-ignore
            code: response_code,
            data,
        },
    }));
};
const responseFailCallback = function (error) {
    var _a;
    // Do something with request error
    const { message = "We are facing an issue. Please try again later.", data, response_code, } = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) || {};
    return Promise.reject(new Error(message, {
        cause: {
            //@ts-ignore
            code: response_code && parseInt(response_code),
            data,
        },
    }));
};

export { listingServiceResponseSuccessCallback, requestFailCallback, responseFailCallback };
